import { createSlice } from '@reduxjs/toolkit';

import { objectToCamelCase } from 'libs/format';
import { buildGenericAdapter } from 'libs/slices';

const themeTemplatesAdapter = buildGenericAdapter();

const initialState = themeTemplatesAdapter.getInitialState();

const themeTemplatesSlice = createSlice({
  name: 'themeTemplates',
  initialState,
  reducers: {
    updateThemeTemplate: (state, action) => {
      const { id, changes } = action.payload;
      const newChanges = objectToCamelCase(changes);
      themeTemplatesAdapter.updateOne(state, { id, changes: newChanges });
    },
    removeThemeTemplate: themeTemplatesAdapter.removeOne,
    setAllThemeTemplates: (state, action) => {
      const themeTemplates = objectToCamelCase(action.payload);
      themeTemplatesAdapter.setAll(state, themeTemplates);
    },
    addThemeTemplate: (state, action) => {
      const themeTemplate = objectToCamelCase(action.payload);
      themeTemplatesAdapter.addOne(state, themeTemplate);
    },
  },
});

export const { addThemeTemplate, setAllThemeTemplates, updateThemeTemplate, removeThemeTemplate } =
  themeTemplatesSlice.actions;

export const {
  selectAll: selectAllThemeTemplates,
  selectById: selectThemeTemplateById,
  selectIds: selectThemeTemplateIds,
} = themeTemplatesAdapter.getSelectors((state) => state.themeTemplates);

export default themeTemplatesSlice.reducer;
